import { render, staticRenderFns } from "./comm-fromUpload.vue?vue&type=template&id=47366a21&scoped=true&"
import script from "./comm-fromUpload.vue?vue&type=script&lang=js&"
export * from "./comm-fromUpload.vue?vue&type=script&lang=js&"
import style0 from "./comm-fromUpload.vue?vue&type=style&index=0&id=47366a21&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47366a21",
  null
  
)

export default component.exports